<ngx-ui-loader></ngx-ui-loader><div ngxUiLoaderBlurred><router-outlet></router-outlet></div><cookie-law learnMore={{this.privacyPolicy}}></cookie-law>